<template>
  <div class="flex-grow-1 col-12 p-0 d-flex flex-column">
    <section class="flex-grow-1 d-flex flex-column iframe__container">
      <!-- Solicitar datos domicilio -->
      <div class="col-12 mt-3" v-if="!showIframe">
        <div class="col-12">
          <small>Información ligada a la tarjeta</small>
          <hr>
        </div>
        <form @submit="getUserData" class="d-flex justify-content-between flex-wrap">
          <div class="form-group col-12 d-flex justify-content-end">
            <input type="checkbox" id="tarjetaEmpresarial" @change="handleEmpresa">
            <label class="ml-2" for="tarjetaEmpresarial">Tarjeta empresarial</label>
          </div>
          <div class="form-group col-6">
            <label for="">Nombre</label>
            <input type="text" name="Nombre" class="form-control" :value="data.Nombre" required />
          </div>
          <div class="form-group col-6" v-if="!esEmpresa">
            <label for="">Apellidos</label>
            <input type="text" name="Apellido" class="form-control" :value="data.Apellidos" required />
          </div>
          <div class="form-group col-6">
            <label for="">Email</label>
            <input type="email" name="Correo" class="form-control" :value="data.Correo" required />
          </div>
          <div class="form-group col-6">
            <label for="">Teléfono</label>
            <input type="text" name="Telefono" class="form-control" required />
          </div>

          <div class="col-12 mt-3">
            <small>Domicilio ligado a la tarjeta</small>
            <hr>
          </div>

          <div class="form-group col-6">
            <label for="">Calle y número</label>
            <input type="text" name="Calle" class="form-control" :value="data.Domicilio.Calle" required />
          </div>
            <div class="form-group col-6">
            <label for="">Ciudad</label>
            <input type="text" name="Ciudad" class="form-control" required />
          </div>
          <div class="form-group col-6">
            <label for="">Estado</label>
            <input type="text" name="Estado" class="form-control" :value="data.Domicilio.Estado" required />
          </div>
          <div class="form-group col-6">
            <label for="">C.P.</label>
            <input type="text" name="CodigoPostal" class="form-control" :value="data.Domicilio.CodigoPostal" required />
          </div>

          <div class="form-group col-12 d-flex justify-content-end">
            <button type="submit" class="btn btn-primary--custom">Pagar</button>
          </div>

        </form>
      </div>

      <iframe
        v-if="showIframe"
        id="paymentIframe"
        class="col-12 flex-grow-1 p-0"
        :src="iframe"
        frameborder="0"
      ></iframe>
    </section>
  </div>
</template>
<style scoped>
iframe {
  height: 100%;
  width: 100%;
  border: none;
  display: block;
}
</style>
<script>
import { loadPartialConfig } from '@babel/core';
import { form } from '../../assets/helpers'
import loadingVue from '../ImgLoading/loading.vue';
import { geturlPago } from "../../store/actions/ModuloActions";

export default {
  data: function () {
    return {
      // Response
      iframe: "",
      showIframe: false,

      bancoRequest: {},

      esEmpresa: false,
    };
  },
  props: {
    data: Object,
  },
  methods: {
    handleEmpresa(e) {
      const isChecked = e.target.checked
      this.esEmpresa = isChecked;
    },
    getUserData(e) {
      e.preventDefault();
      const data = form.build(e.target);
      data.IdBanco = this.data.IdBanco;
      data.IdApp = this.data.IdApp;
      data.Referencia = this.data.Referencia;
      data.Monto = this.data.Monto;
      data.Pais = this.data.Pais;
      data.PromocionMeses = this.data.PromocionMeses;
      data.NumeroPoliza = this.data.NumeroPoliza;
      data.TipoMoneda = this.data.TipoMoneda;
      this.bancoRequest = data;
      this.showIframe = true;
      this.pay();
    },
    async pay() {
      /*const payload = {
        metodo: "PAGOBANCO",
        //data: this.bancoRequest,
        data: {
          IdBanco: "31",
          IdApp: "6",
          Referencia: this.bancoRequest.Referencia,
          Monto: this.bancoRequest.Monto,
          PromocionMeses: "000000",
          NumeroPoliza: this.bancoRequest.NumeroPoliza,
          TipoMoneda: "MXN",
          PromoPlan: "03",
        },
      };

      if ( this.esEmpresa ) {
        payload.data.Apellido = payload.data.Nombre;
      } else {
        payload.data.Apellido = this.bancoRequest.Apellido;
      }
      payload.data.token = this.$route.query.token;
      const response = await this.$store.dispatch("metodoPost", payload);

      if (response) {
        /*const parsedResponse = JSON.parse(
          this.$store.getters.getRespuestaREST.urlPago
        );
        const response = this.$store.getters.getRespuestaREST;
        const billing = JSON.parse(response.urlPago);

        const urlpago = `${billing.urlAcceso}&Monto=${billing.Monto}&Referencia=${billing.refCliente1}&TipoMoneda=${billing.TipoMoneda}&idSistema=${billing.IdSistema}&Folio=${billing.ReferenciaFolio}`;

        this.iframe = urlpago;
      }*/

      /*const framePago = document.getElementById("paymentIframe");
      this.urlPayment = `${geturlPago()}?monto=${this.bancoRequest.Monto}&referencia=${this.bancoRequest.Referencia}&TipoMoneda=MXN&idAplicacion=6&Folio=${this.bancoRequest.NumeroPoliza}&concepto=Pago Auto Diario, de la póliza: ${this.bancoRequest.NumeroPoliza}`;
      framePago.src = this.urlPayment;
      const modal = document.getElementById("polizaModal");
      modal.click();*/
      const urlpago = `${geturlPago()}?monto=${this.bancoRequest.Monto}&referencia=${this.bancoRequest.Referencia}&TipoMoneda=MXN&idAplicacion=6&Folio=${this.bancoRequest.NumeroPoliza}&concepto=Pago Auto Diario, de la póliza: ${this.bancoRequest.NumeroPoliza}`;
      this.iframe = urlpago;
    },
  },
  beforeDestroy() {
    this.$emit("onExit");
  },
};
</script>